import { render } from "./CreateNewTask.vue?vue&type=template&id=1f7f9c08&scoped=true"
import script from "./CreateNewTask.vue?vue&type=script&lang=js"
export * from "./CreateNewTask.vue?vue&type=script&lang=js"

import "./CreateNewTask.vue?vue&type=style&index=0&id=1f7f9c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7f9c08"]])

export default __exports__